<ng-container>
    <div
        [style.backgroundColor]="primaryColour"
        class="py-4 relative text-sub-1">
        <div class="overflow-hidden">
            <div [ngClass]="styles.premiumTextClass">
                <div
                    [isLoading]="isLoading()"
                    [theme]="{
                        margin: 0,
                        height: styles.loaderHeight,
                        right: 0,
                        top: '0',
                    }"
                    libLoader
                    position="absolute"
                    zIndex="1">
                    <div class="min-w-[100px]">
                        {{ premiumDisplay() | currency: 'R' }}
                        p/m
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
